import { SET_PATIENT_ADDRESS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Request {
    _id?: string;
    pid: string;
    address: Address;
}

export interface Address {
    line1: string;
    line2: string;
    city: string;
    state: string;
    place_id: string;
    coordinates: string;
    pincode: string;
}

export interface Response {
    success: boolean;
    error: string;
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(SET_PATIENT_ADDRESS(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
